export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      catalog: "Catalogue",
      about: "Notre histoire",
      admin: "Admin",
      tagline: "fait à la main avec amour",
    },
    common: {
      adopt: "Adopter",
      adoptMe: "Adoptez-moi",
      learnMore: "En savoir plus",
      backToCatalog: "Retour au catalogue",
      loading: "Chargement…",
      currency: "$",
      currencyCode: "CAD",
      hours: "h",
      colors: "Couleurs",
      creationTime: "Temps de création",
      born: "Né(e)",
      personality: "Personnalité",
      adopted: "Adopté",
      sold: "Vendu",
      available: "Disponible",
      unavailable: "Plus disponible",
    },
    home: {
      heroEyebrow: "Atelier artisanal",
      heroTitle: "Des amis conçus à la main, juste pour vous",
      heroSubtitle:
        "Chaque petit compagnon de Lili naît entre ses doigts, maille après maille. Adoptez votre ami unique et recevez son certificat d'adoption signé.",
      heroCta: "Découvrir le refuge",
      heroSecondary: "Notre histoire",
      featuredTitle: "Nos amis qui cherchent une famille",
      featuredSubtitle: "Chaque pièce est unique. Une fois adoptée, elle ne revient pas.",
      storyTitle: "Crochetés avec patience, offerts avec tendresse",
      storyBody:
        "Lili sélectionne ses laines et ses modèles avec soin, puis elle passera des heures avec son crochet à créer chaque maille afin de donner vie à un compagnon que vous ne trouverez nulle part ailleurs. Chaque ami arrive chez vous avec son certificat d'adoption — son nom, sa date de naissance et la signature de Lili.",
      promiseTitle: "La promesse de Lili",
      promiseOne: "100% fait main",
      promiseOneDesc: "Aucune machine. Juste un crochet et beaucoup d'amour.",
      promiseTwo: "Pièce unique",
      promiseTwoDesc: "Un seul ami par modèle. Le vôtre n'aura jamais de jumeau.",
      promiseThree: "Certificat d'adoption",
      promiseThreeDesc: "Un vrai document papier, signé et envoyé avec votre ami.",
    },
    catalog: {
      title: "Le refuge",
      subtitle: "Petits êtres faits à la main, qui n'attendent que vous",
      empty: "Pas encore d'amis disponibles.",
    },
    adopt: {
      title: "Formulaire d'adoption",
      subtitle: "Quelques informations pour préparer l'arrivée de votre nouvel ami",
      buyerInfo: "Vos coordonnées",
      address: "Adresse de livraison",
      giftSection: "Cadeau",
      isGift: "Ceci est un cadeau",
      giftRecipient: "Cadeau pour",
      giftRecipientHelp: "Nom de la personne qui recevra l'ami (apparaîtra sur le certificat)",
      message: "Message personnel sur le certificat",
      messageHelp: "Ce mot apparaîtra sur le certificat papier (optionnel, max 200 caractères)",
      certificatePreview: "Aperçu du certificat",
      total: "Total",
      submit: "Confirmer l'adoption",
      processing: "Traitement…",
      firstName: "Prénom",
      lastName: "Nom",
      email: "E-mail",
      phone: "Téléphone (optionnel)",
      addr1: "Adresse",
      addr2: "Complément d'adresse (optionnel)",
      city: "Ville",
      postal: "Code postal",
      country: "Pays",
      requiredError: "Veuillez remplir tous les champs obligatoires.",
      success: "Adoption confirmée !",
      error: "Une erreur est survenue. Réessayez.",
    },
    confirmation: {
      title: "L'adoption est officielle",
      subtitle: "Merci d'avoir donné une nouvelle maison à",
      orderNumber: "Numéro de commande",
      certificateNumber: "Numéro de certificat",
      download: "Télécharger le certificat (PDF)",
      generating: "Génération du PDF…",
      continueShopping: "Continuer à découvrir",
      shippingInfo: "Votre nouvel ami sera expédié dans 3 à 5 jours ouvrés avec son certificat papier signé.",
    },
    certificate: {
      title: "Certificat d'adoption",
      subtitle: "Les Amis de Lili",
      certifies: "Le présent certificat atteste solennellement que",
      hasAdopted: "a adopté avec amour",
      bornOn: "Né(e) en",
      tookHours: "Temps de création",
      colorsLabel: "Couleurs",
      personalityLabel: "Caractère",
      signedAt: "Fait à l'atelier le",
      signature: "Lili",
      promise:
        "À partir de ce jour, je promets de l'aimer, de lui raconter des histoires et de lui faire une place dans ma famille.",
      certNo: "N°",
    },
    footer: {
      tagline: "Atelier de tricot artisanal",
      description: "Chaque ami est conçu à la main, avec des laines sélectionnées avec soin.",
      rights: "Tous droits réservés",
      links: "Navigation",
      contact: "Contact",
    },
    admin: {
      title: "Tableau de bord",
      subtitle: "Gestion des amis tricotés",
      tabsToys: "Amis",
      tabsOrders: "Adoptions",
      addToy: "Ajouter un ami",
      editToy: "Modifier",
      deleteToy: "Supprimer",
      confirmDelete: "Confirmer la suppression ?",
      relist: "Remettre disponible",
      name: "Nom",
      species: "Espèce",
      price: "Prix",
      colors: "Couleurs (séparées par des virgules)",
      hours: "Heures de création",
      images: "Images",
      uploadImages: "Ajouter des images",
      descFr: "Description (FR)",
      descEn: "Description (EN)",
      personFr: "Personnalité (FR)",
      personEn: "Personnalité (EN)",
      birth: "Date de naissance",
      featured: "Mis en avant",
      available: "Disponible",
      save: "Enregistrer",
      cancel: "Annuler",
      close: "Fermer",
      noOrders: "Aucune adoption pour le moment.",
      orderDetails: "Détails de la commande",
      printCertificate: "Imprimer le certificat",
      shippingAddress: "Adresse de livraison",
      buyerInfo: "Acheteur",
      giftInfo: "Cadeau",
      orderStatus: "Statut",
      statusOrdered: "Commandé",
      statusPaid: "Payé",
      statusShipped: "Expédié",
      statusCompleted: "Terminé",
      yes: "Oui",
      no: "Non",
    },
    about: {
      title: "L'histoire de Lili",
      body: "Tout a commencé par un cadeau pour la fille d'une amie. Une giraffe fait à la main, qui ne ressemblait à aucune autre. Très vite, d'autres personnes de mon entourage en voulaient un aussi.\n\nAujourd'hui, mes créations sont offertes au monde entier. Chaque ami que je crée avec ma laine et mon crochet, part avec son nom, son histoire, et un certificat d'adoption.",
      quote: "Je ne fabrique pas des jouets. Je crée des amis.",
      sign: "— Lili",
    },
  },
  en: {
    nav: {
      home: "Home",
      catalog: "Catalog",
      about: "Our story",
      admin: "Admin",
      tagline: "handmade with love",
    },
    common: {
      adopt: "Adopt",
      adoptMe: "Adopt me",
      learnMore: "Learn more",
      backToCatalog: "Back to catalog",
      loading: "Loading…",
      currency: "$",
      currencyCode: "CAD",
      hours: "h",
      colors: "Colors",
      creationTime: "Creation time",
      born: "Born",
      personality: "Personality",
      adopted: "Adopted",
      sold: "Sold",
      available: "Available",
      unavailable: "No longer available",
    },
    home: {
      heroEyebrow: "Artisan workshop",
      heroTitle: "Hand-crafted friends, made just for you",
      heroSubtitle:
        "Each one of Lili's little companions is born between her fingers, stitch by stitch. Adopt your unique friend and receive his signed adoption certificate.",
      heroCta: "Enter the shelter",
      heroSecondary: "Our story",
      featuredTitle: "Friends looking for a family",
      featuredSubtitle: "Each piece is unique. Once adopted, it's gone for good.",
      storyTitle: "Crocheted with patience, offered with tenderness",
      storyBody:
        "Lili carefully selects her yarns and patterns, then spends hours with her crochet hook creating each stitch to bring to life a companion you'll find nowhere else. Each friend arrives with their adoption certificate — their name, birth date and Lili's signature.",
      promiseTitle: "Lili's promise",
      promiseOne: "100% handmade",
      promiseOneDesc: "No machines. Just one crochet hook and a lot of love.",
      promiseTwo: "One of a kind",
      promiseTwoDesc: "One friend per design. Yours will never have a twin.",
      promiseThree: "Adoption certificate",
      promiseThreeDesc: "A real paper document, signed and shipped with your friend.",
    },
    catalog: {
      title: "The shelter",
      subtitle: "Tiny handmade beings just waiting for you",
      empty: "No friends available yet.",
    },
    adopt: {
      title: "Adoption form",
      subtitle: "A few details to prepare your new friend's arrival",
      buyerInfo: "Your information",
      address: "Shipping address",
      giftSection: "Gift",
      isGift: "This is a gift",
      giftRecipient: "Gift for",
      giftRecipientHelp: "Name of the person who will receive the friend (will appear on the certificate)",
      message: "Personal message on the certificate",
      messageHelp: "This will appear on the paper certificate (optional, 200 chars max)",
      certificatePreview: "Certificate preview",
      total: "Total",
      submit: "Confirm adoption",
      processing: "Processing…",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone (optional)",
      addr1: "Address",
      addr2: "Address line 2 (optional)",
      city: "City",
      postal: "Postal code",
      country: "Country",
      requiredError: "Please fill in all required fields.",
      success: "Adoption confirmed!",
      error: "An error occurred. Please try again.",
    },
    confirmation: {
      title: "The adoption is official",
      subtitle: "Thank you for giving a new home to",
      orderNumber: "Order number",
      certificateNumber: "Certificate number",
      download: "Download certificate (PDF)",
      generating: "Generating PDF…",
      continueShopping: "Keep exploring",
      shippingInfo: "Your new friend will ship within 3 to 5 business days along with the signed paper certificate.",
    },
    certificate: {
      title: "Adoption Certificate",
      subtitle: "Les Amis de Lili",
      certifies: "This certificate solemnly attests that",
      hasAdopted: "has lovingly adopted",
      bornOn: "Born in",
      tookHours: "Creation time",
      colorsLabel: "Colors",
      personalityLabel: "Character",
      signedAt: "Signed at the workshop on",
      signature: "Lili",
      promise:
        "From this day on, I promise to love them, tell them stories, and make a place for them in my family.",
      certNo: "No.",
    },
    footer: {
      tagline: "Artisan knitting workshop",
      description: "Each friend is handcrafted, with carefully selected yarns.",
      rights: "All rights reserved",
      links: "Navigation",
      contact: "Contact",
    },
    admin: {
      title: "Dashboard",
      subtitle: "Manage your knitted friends",
      tabsToys: "Friends",
      tabsOrders: "Adoptions",
      addToy: "Add a friend",
      editToy: "Edit",
      deleteToy: "Delete",
      confirmDelete: "Confirm delete?",
      relist: "Mark as available",
      name: "Name",
      species: "Species",
      price: "Price",
      colors: "Colors (comma separated)",
      hours: "Creation hours",
      images: "Images",
      uploadImages: "Add images",
      descFr: "Description (FR)",
      descEn: "Description (EN)",
      personFr: "Personality (FR)",
      personEn: "Personality (EN)",
      birth: "Birth date",
      featured: "Featured",
      available: "Available",
      save: "Save",
      cancel: "Cancel",
      noOrders: "No adoptions yet.",
    },
    about: {
      title: "Lili's story",
      body: "It all started with a gift for a friend's daughter. A handmade giraffe, unlike any other. Very quickly, other people around me wanted one too.\n\nToday, my creations are offered to the whole world. Each friend I make with my yarn and crochet hook leaves with their name, their story, and an adoption certificate.",
      quote: "I don't make toys. I create friends.",
      sign: "— Lili",
    },
  },
};
